import React, { useState } from 'react';

/**
 * Zeigt den einmaligen Wiederherstellungs-Code nach der Einrichtung. Ohne diesen
 * Code (und ohne Passphrase) sind die Daten unwiederbringlich verloren - daher
 * muss der Nutzer das Sichern aktiv bestaetigen.
 */
export default function RecoveryDialog({ recoveryCode, keyfileGeladen, onFertig }) {
  const [bestaetigt, setBestaetigt] = useState(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-2xl bg-paper p-6 shadow-xl">
        <h2 className="font-serif text-xl font-semibold text-ink">Wiederherstellungs-Code sichern</h2>
        <p className="mt-2 text-sm text-ink-muted">
          Bewahre diesen Code sicher auf (z.&nbsp;B. Passwort-Manager oder ausgedruckt). Er ist die
          <strong> einzige </strong>
          Möglichkeit, deinen Tresor zu retten, falls du die Passphrase vergisst.
        </p>

        <pre className="mt-4 select-all rounded-xl border border-line bg-paper-sunken px-4 py-3 text-center font-mono text-lg tracking-widest text-ink">
          {recoveryCode}
        </pre>

        {keyfileGeladen && (
          <p className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">
            Deine Schlüsseldatei wurde heruntergeladen. Ohne sie lässt sich der Tresor nicht entsperren –
            lege sie an einen sicheren Ort (z.&nbsp;B. USB-Stick).
          </p>
        )}

        <label className="mt-4 flex cursor-pointer items-start gap-2 text-sm text-ink">
          <input
            type="checkbox"
            checked={bestaetigt}
            onChange={(e) => setBestaetigt(e.target.checked)}
            className="mt-0.5 h-4 w-4 accent-brand-600"
          />
          Ich habe den Code (und ggf. die Schlüsseldatei) sicher gespeichert.
        </label>

        <button
          type="button"
          disabled={!bestaetigt}
          onClick={onFertig}
          className="mt-5 w-full rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-500 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Weiter
        </button>
      </div>
    </div>
  );
}
